import PageDescription from 'components/PageDescription';

import { toStoreCouponsLink, toStoreOffersLink } from 'lib/links';

const TOPICS = [
  {
    title: 'Seleção de Ofertas Grátis do Promobit',
    paragraphs: [
      'O Promobit tem as melhores promoções de produtos da internet. Mas também tem outras vantagens, como as ofertas grátis. O que você quer ganhar: amostras, jogos, eBooks, produtos de beleza, cupons de alimentação? É claro que você vai aproveitar todas oportunidades!',
      'Confira abaixo um pouco do que sempre oferecemos a toda comunidade!',
    ],
    subtopics: [
      {
        title: 'Jogos',
        paragraphs: [
          ' A comunidade Promobit mostra que gosta e entende muito de jogos. Por isso, a categoria de ofertas gratuitas sempre está repleta de títulos para variadas plataformas.',
          'Para ilustrar a diversidade de jogos grátis que aparecem por aqui, vale citar alguns como: “Until Dawn: Rush of Blood”, “Fishing Planet”, “HEX: Card Clash” e outros, todos para PS4. Para Android: “13 Days of Life”, “Survival Online GO”, “Dexter Slice” e mais. Para PC: “100 % Hidden Objects 2”, “Painkiller Hell & Damnation”, “Strike Suit Zero”. Para Xbox 360: “Child of Eden” e outros.',
          `Confira também <a href=${toStoreCouponsLink(
            'saraiva'
          )}>os cupons de descontos Saraiva</a> e ganhe vantagens na compra de jogos.`,
        ],
      },
      {
        title: 'Amostras grátis',
        paragraphs: [
          'Quem não gosta de ganhar amostras? Testar um produto sem pagar nada por ele é uma oportunidade de conhecer lançamentos de itens em geral. A comunidade sempre aproveita as chances e depois acrescenta muito compartilhando as análises.',
          'Quais são os tipos de amostras que aparecem por aqui? Amostra de roupas íntimas descartáveis, produto de higiene de marcas reconhecidas pelo mercado, absorventes, itens de alimentação e muito mais.',
        ],
      },
      {
        title: 'Beleza',
        paragraphs: [
          'Grandes marcas de cosméticos e maquiagem sempre investem na distribuição de brindes. A comunidade sempre traz essas novidades para o Promobit.',
          `Uma das ofertas grátis de maior sucesso por aqui é a <a href=${toStoreOffersLink(
            'quem-disse-berenice'
          )}>“Retorna Berê”</a> da <a href=${toStoreCouponsLink(
            'quem-disse-berenice'
          )}>“Quem disse, Berenice?”</a>. Promoção permanente, a empresa presenteia mulheres que buscam as lojas da marca para ajudar a reciclar embalagens vazia. Aproveite nossas ofertas grátis, mas também pegue os <a href=${toStoreCouponsLink(
            'oboticario'
          )}>cupons de desconto Boticário</a>!`,
        ],
      },
      {
        title: 'Anuidade',
        paragraphs: [
          'Cartão de crédito ajuda em várias necessidades do dia a dia. Mas nem sempre as pessoas podem ou acham vantajoso pagar anuidade para receber os benefícios das operadoras.',
          'De olho nisso, o Promobit sempre reúne oportunidades de grandes empresas e das lojas mais seguras do varejo.',
          'Dê uma olhada nas nossas ofertas grátis de anuidade e aproveite para adquirir o cartão que for melhor para você.',
        ],
      },
      {
        title: 'Cursos',
        paragraphs: [
          'A comunidade sempre preza por oportunidades que colaboram com a educação e profissionalização.',
          'Cursos de informática, EAD e ofertas do MEC são alguns exemplos de promoções gratuitas que aparecem por aqui.',
          `Encontre mais sugestões com os <a href=${toStoreCouponsLink(
            'udemy'
          )}>cupons de descontos Udemy.</a>`,
        ],
      },
      {
        title: 'eBooks',
        paragraphs: [
          'Leitura é outro ponto forte da comunidade Promobit. Quer baixar um eBook gratuitamente? Então, aproveite! A nossa biblioteca é rica em títulos e gêneros.',
          'O que você gosta de ler? Clássicos da literatura? Best-sellers? Estudos de tecnologia e informática? Aqui tem eBook para todos os gostos!',
        ],
      },
      {
        title: 'Consulte os eBooks gratuitos da Livraria Cultura',
        paragraphs: [
          'Aproveite as ofertas grátis do Promobit! Para não perder as ofertas grátis do Promobit, crie alertas personalizados. Pelo navegador, clique no ícone de coração, à direita. Pelo aplicativo, ative o botão do sino.',
          ' E se tiver alguma sugestão, clique em “Sugerir oferta” e deixe a comunidade ainda mais interessante com a sua colaboração!',
        ],
      },
    ],
  },
];

const FreeOffersPageDescription = () => (
  <PageDescription
    className="mt-8 bg-transparent dark:bg-transparent"
    headingSizes={[
      { size: 'size3', as: 'h2' },
      { size: 'size4', as: 'h4' },
    ]}
    pageDescription={TOPICS}
    paragraphPropsClassName="mb-0"
  />
);

export default FreeOffersPageDescription;
